import styles from "./EventCardList.module.css";
import PropTypes from "prop-types";

import { useState, useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import nextId from "react-id-generator";
// import Calendar from "../IBOCalendar";
import EventCard from "Security/IncidentsPage/EventCard";
import classNames from "classnames";

/**
 * List of event incidents cards
 *
 */

export function EventCardList({ eventsArray }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref, {
    // needs to be named "events"!
    applyRubberBandEffect: true,
  }); // Now we pass the reference to the useDraggable hook:
  const draggerId = "adminsDraggerId" + nextId();

  return (
    <>
      <div className={styles.container}>
        <div
          className={classNames(styles.cardsContainer, styles.dragger)}
          {...events}
          ref={ref}
          id={draggerId}
        >
          {eventsArray.map((item, index) => (
            <div key={index} className={styles.card}>
              <EventCard eventInfo={item} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

EventCardList.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  // onClick: PropTypes.func,
};
